import SharedNavbar from '../../../components/feature/SharedNavbar';
import SharedFooter from '../../../components/feature/SharedFooter';
import FloatingCallButton from '../../../components/feature/FloatingCallButton';
import ServiceHero from '../components/ServiceHero';
import ServiceContent from '../components/ServiceContent';
import ServiceCTA from '../components/ServiceCTA';

export default function FaultDetectionPage() {
  const serviceData = {
    title: 'Electrical Fault Detection',
    subtitle: 'Advanced Diagnostic Services',
    description: 'Experiencing electrical issues but can\'t identify the cause? Our expert electricians use advanced diagnostic equipment to quickly locate and resolve electrical faults. We provide comprehensive fault finding services to ensure your electrical system operates safely and efficiently.',
    heroImage: 'https://public.readdy.ai/ai/img_res/e7bb35ceb13354059a0a9ed32179c5c8.jpg',
    features: [
      {
        icon: 'ri-search-line',
        title: 'Advanced Diagnostics',
        description: 'State-of-the-art testing equipment for accurate detection'
      },
      {
        icon: 'ri-flashlight-line',
        title: 'Quick Identification',
        description: 'Rapid fault location to minimize downtime'
      },
      {
        icon: 'ri-file-list-3-line',
        title: 'Detailed Reports',
        description: 'Comprehensive documentation of findings'
      },
      {
        icon: 'ri-tools-line',
        title: 'Complete Repairs',
        description: 'Full resolution of identified issues'
      }
    ],
    benefits: [
      'Thermal imaging inspections',
      'Circuit testing and analysis',
      'Earth leakage detection',
      'Voltage drop testing',
      'Insulation resistance testing',
      'RCD and safety switch testing',
      'Switchboard fault finding',
      'Detailed fault reports'
    ],
    processSteps: [
      {
        number: '01',
        title: 'Initial Assessment',
        description: 'Discuss symptoms and electrical behavior'
      },
      {
        number: '02',
        title: 'Diagnostic Testing',
        description: 'Use specialized equipment to locate faults'
      },
      {
        number: '03',
        title: 'Fault Identification',
        description: 'Pinpoint exact cause and extent of issues'
      },
      {
        number: '04',
        title: 'Repair & Verify',
        description: 'Fix problems and confirm proper operation'
      }
    ]
  };

  return (
    <div className="min-h-screen bg-white">
      <SharedNavbar />
      <ServiceHero 
        title={serviceData.title}
        subtitle={serviceData.subtitle}
        description={serviceData.description}
        heroImage={serviceData.heroImage}
      />
      <ServiceContent 
        features={serviceData.features}
        benefits={serviceData.benefits}
        processSteps={serviceData.processSteps}
      />
      <ServiceCTA />
      <div className="pb-20 lg:pb-0">
        <SharedFooter />
      </div>
      <FloatingCallButton />
    </div>
  );
}